module.exports = __webpack_public_path__ + "media/images/icons/rss-8b8d07e0ebf86576aa1754371c77be53.svg";